export default __webpack_public_path__ + "assets/gibraltar-flag.png";